module.exports = {
  HR: 'Hrvatski',
  EN: 'Engleski',
  SI: 'Slovenski',
  RU: 'Ruski',
  DE: 'Njemački',
};
